<template>
  <div class="SubPage__container">
    <PageHeader1XP />
    <main id="main">
      <Breadcrumbs :crumbs="crumbs" />
      <section class="SubPage__contentGrid SubPage__firstGrid">
        <!-- <div id="breadcrumbs-home" onclick="window.location.href='startseite.WIKA'"></div>
        <ol class="Breadcrumbs__container" vocab="http://schema.org/" typeof="BreadcrumbList"><li property="itemListElement" typeof="ListItem"><a property="item" typeof="ListItem" href="loesungen.WIKA" target="_top"><span property="name">Lösungen</span></a><meta property="position" content="0"></li><li property="itemListElement" typeof="ListItem"><a property="item" typeof="ListItem" href="branchen.WIKA" target="_top"><span property="name">Branchen</span></a><meta property="position" content="0"></li><li property="itemListElement" typeof="ListItem"><a property="item" typeof="ListItem" href="kaeltetechnik.WIKA" target="_top"><span property="name">column</span></a><meta property="position" content="0"></li><li property="itemListElement" typeof="ListItem"><a property="item" typeof="ListItem" href="grundstoffe_mineralien_metalle_papier.WIKA" target="_top"><span property="name">some page that has an unreasonably long title, obviously running away from the point instead of bringing it closer</span></a><meta property="position" content="0"></li><li><a href="#"><span property="name">One more: some page that has an unreasonably long title, obviously running away from the point instead of bringing it closer</span></a><meta property="position"></li></ol> -->
        <div class="SubPage__header columns is-variable is-mobile">
          <div class="column">
            <Button1XP
              size="s"
              start-icon="arrow_back"
              text="Zurück zur Übersicht"
              url="#"
              variant="link"
            />
          </div>
        </div>
        <div class="columns is-gapless">
          <div class="column is-two-thirds">
            <HeaderBox
              :links="['Datenblatt']"
              :shop-extras="{
                linkText: 'Weitere Informationen (WIKA-Webseite)',
                url: '#',
                deliveryNotice:
                  'Lieferhinweis: Lagergeräte sofort versandfertig; Fertigungsgeräte siehe Artikeldetails.',
              }"
              text="Für die Prozessindustrie, Standardausführung, NG 63, 100 und 160"
              title="Rohrfedermanometer, CrNi-Stahl"
              type="Typen 111.10, 111.12"
              :warning="{
                title: 'Warning',
                text: 'This product can expose you to chemicals including Nickel and Chromium, which is known to the State of California to cause cancer and reproductive harm. For more information go to www.P65Warnings.ca.gov',
                url: '#',
              }"
            />
          </div>
          <div class="column is-one-third">
            <div class="SubPage__shopImage">
              <ImageMagnifier
                :alt="shopConfig.headline"
                height="auto"
                mask-bg-color="#434140"
                mask-height="70"
                mask-width="70"
                :orientation="shopConfig.zoomOrientation"
                :scale="2"
                :src="shopConfig.pictureurl"
                width="100%"
                :zoom-src="shopConfig.imageZoom ?? shopConfig.pictureurl"
              />
              <span class="SubPage__shopImageCaption">Beispielhafte Darstellung</span>
            </div>
          </div>
        </div>
      </section>
      <section class="SubPage__contentGrid">
        <ProductDetailTabs :config="tabsConfig" :shop-config="shopConfig" />
        <ProductSlider :config="slider1" />
        <ProductSlider :config="slider2" />
      </section>
    </main>
    <Footer1XP />
  </div>
</template>

<script setup>
import Button1XP from '../Button1XP/Button1XP.vue';
import Breadcrumbs from '../Breadcrumbs/Breadcrumbs.vue';
import Footer1XP from '../Footer1XP/Footer1XP.vue';
import HeaderBox from '../HeaderBox/HeaderBox.vue';
import ImageMagnifier from '../ImageMagnifier/ImageMagnifier.vue';
import ProductSlider from '../ProductSlider/ProductSlider.vue';
import { onBeforeMount } from 'vue';
import ProductDetailTabs from '../../components/ProductDetailTabs/ProductDetailTabs.vue';
import PageHeader1XP from '../PageHeader1XP/PageHeader1XP.vue';

defineProps({
  crumbs: undefined,
  tabsConfig: undefined,
  shopConfig: undefined,
  slider1: undefined,
  slider2: undefined,
  shopPageHeaderDefaultConfig: {
    type: Object,
    default: () => ({}),
  },
});

onBeforeMount(() => {
  window.instance = 'shop';
});
</script>
